import { markRaw } from "vue";
import Status from "@/components/common/Status.vue";
import OffersActions from "@/components/OffersActions.vue";
import dateHelper from "@/helpers/dateHelper";
import { useTable } from "./useTable";

export const useOffersTable = (onRemove, onUpdate) => {
  const tableStructure = (offer) => {
    return {
      organizationNumber: offer.organizationNumber,
      offerName: offer.offerName,
      subscription: {
        component: markRaw(Status),
        componentProps: {
          status: offer.accountOfferSubscription,
          neutral: !offer.accountOfferSubscription,
          title: offer.accountOfferSubscription ? "Aktiv" : "Ej aktiverad",
        },
      },
      date: dateHelper.getShortDateWithTime(offer.created),
      actions: {
        component: markRaw(OffersActions),
        componentProps: {
          offer,
          onRemoved: onRemove,
          onUpdated: onUpdate,
        },
      },
    };
  };

  const table = useTable(tableStructure);

  const getTableContent = (offers) => {
    return offers.map((offer) => ({
      id: offer.accountOfferId,
      status: offer.accountOfferSubscription ? "#509E2F" : "#FFFFFF",
      items: table.getTableRowFormat(offer),
    }));
  };

  const getTableHeaders = () => {
    return [
      { name: "Organisationsnummer" },
      { name: "Erbjudandenamn" },
      { name: "Abonnemang", sortBy: "subscription" },
      { name: "Datum", sortBy: "created" },
      { name: "Hantera" },
    ];
  };

  const sortTable = (offers, sortKey, order) => {
    if (sortKey === "created") {
      return offers.sort((a, b) => {
        const difference = Date.parse(a.created) - Date.parse(b.created);
        return order === "asc" ? difference : -difference;
      });
    } else if (sortKey === "subscription") {
      return offers.sort((a, b) => {
        const difference =
          Number(a.accountOfferSubscription) -
          Number(b.accountOfferSubscription);
        return order === "asc" ? difference : -difference;
      });
    }

    return table.sortTable(offers, sortKey, order);
  };

  return {
    tableStructure,
    getTableHeaders,
    getTableContent,
    sortTable,
  };
};
